import styled from '@emotion/styled';

interface FlatExperienceWrapperProps
  extends React.HTMLAttributes<HTMLDivElement> {
  theme?: any;
  isLast?: boolean;
  isFirst?: boolean;
}

export const BookmarkWrapper = styled.div<FlatExperienceWrapperProps>`
  padding-bottom: ${({ isLast }) => (isLast ? '0' : '8px')};
`;

export const NoBookmarksText = styled.div`
  font-family: NokiaPureText-Regular;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.blueBlack};
  text-align: center;
  margin-top: 16px;
`;
